import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';
import { hydrateFormData, updateFormData } from '../../utils/formDataParser';
import { TSpotlightData, TSubmitSpotlightData } from '../../utils/types';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateSpotlight } = useService();

	const updateSpotlight = (updatedData: Partial<TSpotlightData>) => {
		setShowLoader(true);

		requestUpdateSpotlight(app.appName, updatedData).then(
			(res: any) => {
				showAlert('Spotlight Updated');
				setShowLoader(false);
				history.goBack();

				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the spotlight', { type: 'error' });
					setShowLoader(false);
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: TSubmitSpotlightData) => {
		updateSpotlight(updateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
